import { Queue } from '@rossum/api-client/queues';
import { useSchema } from '../../../../business/schema/useSchema';
import Loader from '../../../Loader';
import { AutomationPage } from './AutomationPage';

type Props = {
  selectedQueue: Queue;
  parentPath: string;
};

const AutomationDetail = ({ selectedQueue, parentPath }: Props) => {
  const { data: schema, isLoading } = useSchema(selectedQueue.schema);

  if (isLoading || !schema) {
    return <Loader />;
  }

  return (
    <AutomationPage
      selectedQueue={selectedQueue}
      parentPath={parentPath}
      schema={schema}
    />
  );
};

export default AutomationDetail;
